/* global indexUrl integrationConfigured syncEnabled action toggleErpUrl model syncNowUrl updateUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import classNames from 'classnames';

import ToggleTrackingCategoriesSync from '../integrations/activation/ToggleTrackingCategoriesSync';

import TrackingCategoriesTableRow from './TrackingCategoriesTableRow';

import useApiRequest from 'Hooks/useApiRequest';
import { useToast } from 'Hooks/useToast';

export default function TrackingCategoriesIndex(props) {
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState({});
    const [editedCategory, setEditedCategory] = useState(null);

    const fetchCategoriesRequest = useApiRequest({ url: props.indexUrl });
    const toast = useToast();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        fetchCategoriesRequest.get().then((res) => {
            const { data } = res;

            setCategories(data.categories);
            setLocations(data.locations);
        });
    };

    const editCategory = (category) => {
        setEditedCategory(category);
    };

    const cancelEdit = () => {
        setEditedCategory(null);
    };

    const saveCategory = () => {
        axios
            .put(props.updateUrl.replace('TRACKING_OPTION_ID', editedCategory.id), editedCategory)
            .then((response) => {
                const category = response.data.category;

                const items = categories.map((cat, index) => {
                    if (category.id === cat.id) {
                        return category;
                    }
                    return cat;
                });
                setCategories(items);

                toast.success($t('Option updated successfully.'));

                cancelEdit();
            })
            .catch((error) => {
                toast.error($t('An error occurred while updating the option'));
                console.log(error.response);
            });
    };

    const getDepartmentsOptions = () => {
        const options = [];

        if (Object.keys(locations).length === 0) {
            return options;
        }

        const expenditure = locations.expenditure;
        const revenue = locations.revenue;

        if (expenditure.length === 0 || revenue.length === 0) {
            return revenue.concat(expenditure);
        }

        const revenueOptions = {
            label: $t('Revenue'),
            options: [],
        };
        revenue.forEach((item) => {
            revenueOptions.options.push({ value: item.typed_id, label: item.location_name });
        });
        options.push(revenueOptions);

        const expenditureOptions = {
            label: $t('Expenditure'),
            options: [],
        };
        expenditure.forEach((item) => {
            expenditureOptions.options.push({ value: item.typed_id, label: item.location_name });
        });
        options.push(expenditureOptions);

        return options;
    };

    const changeAllocation = (index, e) => {
        const value = e.value;
        const data = JSON.parse(JSON.stringify(editedCategory));

        data.typed_id = value;
        setEditedCategory(data);
    };

    return (
        <div className="tw-pb-10">
            <div className="table__card tw-mb-5">
                <div className="tw-mb-3">
                    <div className="tw-flex tw-justify-between tw-items-start">
                        <h3 className="tw-my-3">{$t('Categories')}</h3>
                        <div className="tw-flex tw-gap-x-1.5">
                            <ToggleTrackingCategoriesSync
                                integrationConfigured={props.integrationConfigured}
                                syncEnabled={props.syncEnabled}
                                action={props.action}
                                toggleUrl={props.toggleUrl}
                                model={props.model}
                                syncNowUrl={props.syncNowUrl}
                                toggleCallback={() => {
                                    fetchData();
                                }}
                            />
                        </div>
                    </div>
                    <div className={classNames('inbud-table_wrapper', 'tw-overflow-auto', 'tw-relative')}>
                        <table className="inbud-table tw-w-full">
                            <thead>
                                <tr>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4">{$t('Category')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4">{$t('Option')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4">{$t('Department / Costcenter')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4">{$t('Actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories.map((category) => {
                                    return (
                                        <TrackingCategoriesTableRow
                                            key={category.id}
                                            category={category}
                                            editedCategory={editedCategory}
                                            saveCategory={saveCategory}
                                            cancelEdit={cancelEdit}
                                            editCategory={editCategory}
                                            locations={locations}
                                            departmentOptions={getDepartmentsOptions()}
                                            changeAllocation={changeAllocation}
                                            setCategories={setCategories}
                                        />
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('trackingCategoriesTable')) {
    var rootEl = document.getElementById('trackingCategoriesTable'); // data attributes below help us
    ReactDOM.render(
        <App>
            <TrackingCategoriesIndex
                indexUrl={indexUrl}
                integrationConfigured={integrationConfigured}
                syncEnabled={syncEnabled}
                action={action}
                toggleUrl={toggleErpUrl}
                model={model}
                syncNowUrl={syncNowUrl}
                updateUrl={updateUrl}
            />
        </App>,
        rootEl,
    );
}
